module.exports = __webpack_public_path__ + "media/src/assets/face-logo-d1acd954c440be44a5332ce54d1ff237.png";